export default [

     {
          path: '/kri',
          name: 'Kri',
          component: () => import("@/views/Page/Kri/Kri.vue"),
           meta: {
               title: 'Kri',
          },
     }
];